import { configureStore } from "@reduxjs/toolkit";
import FilterSlice from "./Reducers/FilterSlice";
import FormWizardTwoSlice from "./Reducers/FormWizardTwoSlice";
import LayoutSlice from "./Reducers/LayoutSlice";
import NumberingWizardSlice from "./Reducers/NumberingWizardSlice";
import ProductSlice from "./Reducers/ProductSlice";
import StudentWizardSlice from "./Reducers/StudentWizardSlice";
import ThemeCustomizerSlice from "./Reducers/ThemeCustomizerSlice";
import TwoFactorSlice from "./Reducers/TwoFactorSlice";
import VerticalWizardSlice from "./Reducers/VerticalWizardSlice";

const Store = configureStore({
  reducer: {
    layout: LayoutSlice,
    twoFactor: TwoFactorSlice,
    formWizardTwo: FormWizardTwoSlice,
    numberingWizard: NumberingWizardSlice,
    studentWizard: StudentWizardSlice,
    verticalWizard: VerticalWizardSlice,
    product: ProductSlice,
    filterData: FilterSlice,
    themeCustomizer: ThemeCustomizerSlice,
  },
});

export default Store;

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
